module.exports = __webpack_public_path__ + "img/jkx-on.3cc463c7.svg";